// extracted by mini-css-extract-plugin
module.exports = {"contents":"contents-1EABRJsGbDgS962PRqWivk","body":"body-Ef12q90aVa82S_QqMw2zG"};